import { Field } from '@app/Tenant/Applications/Airsweb/Models';

const RULE_LISTS = [
    'VisibleWhenRules',
    'VisibleWhenOrRules',
    'HideWhenRules',
    'HideWhenOrRules',
    'MandatoryWhenRules',
    'MandatoryWhenOrRules'
] as const;

function flatten(fields: Field[] | null | undefined): Field[] {
    const output: Field[] = [];
    for (const field of fields ?? []) {
        if (!field) {
            continue;
        }
        output.push(field, ...flatten(field.MultiFields));
    }
    return output;
}

function namesOf(field: Field): string[] {
    return [
        field.FieldId,
        ...(field.ModelPropertyNames ?? []),
        ...(field.Mappings ?? []).map(mapping => mapping?.ModelPropertyName)
    ].filter((name): name is string => !!name);
}

// Finds every field whose visibility, hide, or mandatory rules point at the
// target field, one of its nested multi children, its model property names,
// or its mapping names. Used to warn before a delete, and after a rename,
// that leaves those rules pointing at a missing field.
export function findRuleReferences(fields: Field[], target: Field): Field[] {
    const targetFields = flatten([target]);
    const targetNames = new Set(targetFields.flatMap(namesOf));
    const targetIds = new Set(targetFields.map(f => f.FieldId));

    return flatten(fields).filter(field =>
        !targetFields.includes(field) &&
        !targetIds.has(field.FieldId) &&
        RULE_LISTS.some(list => (field[list] ?? []).some(rule => targetNames.has(rule?.PropertyName ?? '')))
    );
}
